var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThoughtBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 334.446,
    height: 353.263,
    viewBox: "0 0 334.446 353.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 334.446,
    height: 353.263,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M335.531,129.213a49.137,49.137,0,0,0-28.352-45.929c5.739-40.185-42.842-69.493-75.708-46.528C219.493,1.286,165.592-5.187,145.53,26.476,123.4,5.369,82.33,13.325,69.543,40.653c-44.613-14.5-82.344,40.3-53.429,76.726-30.544,34.276,2.792,90.618,47.833,79.9,10.969,29.592,53.9,39.949,77.223,18.188,18.865,23.4,60.445,21.178,76.737-3.875,28.669,18.372,70.086-1.26,73.942-34.936a49.135,49.135,0,0,0,43.682-47.438",
    transform: "translate(-2.882 -4.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M330.884,125.122c.455-18.407-10.782-37.152-27.15-45.551,3.883-41.154-42.17-68.3-75.988-44.181C215-1.64,164.713-8.164,142.868,24.3,119.591,2.33,81.457,8.813,67.012,37.418,21.517,25.387-14.213,75.4,14.749,113.375c-30.544,35.28,2.167,88.71,47.451,77.647,12.128,31.1,51.84,40.077,76.317,17.49,19.2,24.458,59.054,22.582,76.028-3.42,28.635,19.377,69.2,1.227,73.843-33.065,24.13-3.112,40.978-23.057,42.5-46.905m3.531.1c.624,24.544-21.229,46.52-45.376,48.045l.582-.561c-4.3,35.121-45.359,54.878-75.546,36.417l2.445-.5c-18.447,26.633-58.655,28.715-79.809,4.194l2.947.2c-25.743,22.522-67.449,12.619-80.357-19.04l2.171,1.126c-47.795,9.643-80.446-45.166-49.137-82.535l-.042,1.481c-29.117-38.589,8.111-93.546,54.569-78.1l-.809.339C81.185,7.73,118.936.313,143.487,21.481l-1.877.223c22.748-33.23,74.115-27.152,88.625,10.365l-2.615-.832C263.246,8.1,310.294,36.969,304.827,79.3l-.3-.541c19.259,7.855,30.6,25.7,29.892,46.462",
    transform: "translate(0 0.001)",
    fill: "#298fc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M642.838,721.128c-.223,15.714-17.128,25.134-29.794,14.912-11.572-9.1-10.431-28.335,3.886-34.008,13.221-5.477,26.63,5.19,25.908,19.1m-1.522-.043c.419-11.471-12.751-19.573-23.109-15.707-12.458,4.091-16.01,22.2-4.156,29.247,10.409,6.579,27.007-.675,27.265-13.541",
    transform: "translate(-412.081 -472.84)",
    fill: "#298fc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M592.93,906.66c-.092,12.943-13.9,18.845-22.567,8.769-6.581-6.911-4.9-19.206,4.469-22.762,9.713-3.983,18.807,4.007,18.1,13.993m-.355-.01c.222-6.462-6.268-11.112-12.238-11.182-7.647-.376-14.07,7.8-11.639,15.149,3.69,11.531,23.513,7.567,23.877-3.967",
    transform: "translate(-405.543 -644.026)",
    fill: "#298fc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M508.281,1010.493c-.422,14.884-16.933,12.118-18.746-.531-.554-14.007,20-14.209,18.746.531m-.4-.011c.125-4.33-4.566-6.805-8.341-6.841-4.767-.2-9.021,4.766-7.718,9.471,2.085,7.383,15.8,4.389,16.059-2.63",
    transform: "translate(-353.166 -739.721)",
    fill: "#298fc2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtBubble);
export default __webpack_public_path__ + "static/media/thought-bubble.473880589ec96bf6075d77f3a233d0ce.svg";
export { ForwardRef as ReactComponent };